import React from 'react';
import PropTypes from 'prop-types';

import { colors } from 'app/variables';

import Layout from '../Layout';
import Heading from '../Heading';

function PasswordResetLayout({ error, success, children }) {
  return (
    <Layout>
      <Heading
        style={{
          color: error ? colors.amaranth : success ? colors.java : undefined,
        }}
      >
        {i18n.gettext('Password reset')}
      </Heading>
      {children}
    </Layout>
  );
}

PasswordResetLayout.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  children: PropTypes.node,
};

export default PasswordResetLayout;
